import React from 'react';
import Skeleton from 'react-loading-skeleton';
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonComponent = ({...rest}) => {
  return (
    <Skeleton baseColor='#f2f2f2' {...rest}/>
  )
}

export default SkeletonComponent;
